import { z } from 'zod';

export const TransformNotStartedDetails = z.object({
  status: z.literal('NotStarted'),
});

export type TransformNotStartedDetails = z.infer<
  typeof TransformNotStartedDetails
>;
